import { CreateButton, TopToolbar } from "react-admin";
import { Stack } from "@mui/material";
import * as React from "react";

const QuestionDocumentTypeActions = () => (
  <TopToolbar>
    <Stack direction='row' spacing={1}>
      <CreateButton/>
    </Stack>
  </TopToolbar>
);

export default QuestionDocumentTypeActions;
